import React from 'react';
import { cloneDeep } from 'lodash';
import propTypes from 'prop-types';

import { GeoJsonLayer } from 'mapping/leaflet';
import { useAppSelector } from 'app/hooks';
import { isMultiLayerZoneGenerationEnabled } from 'manual/selectors';


/** Renders a collection of zones, with one child layer for each zone. */
const ZoneCollectionLayer = ({
  layerName,
  onClickZone,
  onEachFeature,
  map,
  styleFunction,
  zones,
  zoneIsDisabled = () => false,
  zoneIsSelected = () => false
}) => {
  const isMultiLayerEnabled = useAppSelector(isMultiLayerZoneGenerationEnabled);

  if (!zones) {
    return null;
  }

  const layers = Object.keys(zones).map((zoneId, index) => {
    const zone = zones[zoneId];
    const geoJson = cloneDeep(zone.geoJson);
    const key = `${layerName}-${index}`;

    geoJson.properties.isSelected = zoneIsSelected(zone);

    const _onSelectPoly = onClickZone ? () => {
      if (!zoneIsDisabled(zone)) {
        onClickZone(zoneId);
      }
    } : null; // Passing null indicates that layer is not interactive.
    const _onEachFeature = (feature, layer) => {
      if (onEachFeature) {
        onEachFeature(zone, layer);
      }
    };

    return (
      <GeoJsonLayer
        geoJson={geoJson}
        key={key}
        layerStyle={styleFunction.bind(null, zone, isMultiLayerEnabled ? zones : undefined)}
        map={map}
        onEachFeature={_onEachFeature}
        onSelectPoly={_onSelectPoly}
      />
    );
  });

  const classString = `vra-layer vra-layer--${layerName}`;
  return (
    <div className={classString}>
      {layers}
    </div>
  );
};

ZoneCollectionLayer.propTypes = {
  layerName: propTypes.string.isRequired,
  map: propTypes.object, // Inserted by mapping/leaflet.
  onClickZone: propTypes.func,
  onEachFeature: propTypes.func,
  styleFunction: propTypes.func,
  zoneIsDisabled: propTypes.func,
  zoneIsSelected: propTypes.func,
  zones: propTypes.object.isRequired
};

export default ZoneCollectionLayer;
